import { render, staticRenderFns } from "./LoadItem.vue?vue&type=template&id=092be042"
import script from "./LoadItem.vue?vue&type=script&lang=js"
export * from "./LoadItem.vue?vue&type=script&lang=js"
import style0 from "./LoadItem.vue?vue&type=style&index=0&id=092be042&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel,VExpansionPanelContent})
